import React from 'react';
import { Link } from 'react-router-dom';
import type { User } from '../lib/api';

interface HeaderProps {
  user: User;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout }) => {
  return (
    <header className="topbar">
      <div className="topbarLeft">
        <span className="eyebrow">Personal data removal</span>
        <strong className="topbarTitle">Exact-source indexing and broker removal drafts</strong>
      </div>

      <div className="topbarRight">
        <div className="systemPill"><span className="liveDot" /> Ready</div>
        <Link className="settingsLink" to="/settings">Settings</Link>
        <div className="userBlock">
          <span className="avatar">{user.email.slice(0, 1).toUpperCase()}</span>
          <span>{user.email}</span>
        </div>
        <button type="button" className="ghostButton smallButton" onClick={onLogout}>Logout</button>
      </div>
    </header>
  );
};

export default Header;
